import { PAYMENT_NETWORKS } from "../../utils/enums";
import targetConfig from './target';

export const targetClassaction = {
  ...targetConfig,
  id: PAYMENT_NETWORKS.EGIFT_BLACKHAWK_TARGET_CLASSACTION,
}

export default targetClassaction;
